<template>
  <div class="box_bain">
    <div class="banner_cnt">
      <div :class="lange=='en'?'index_b_box':'index_b_box index_m_box'">
        <span class="index_b_1">{{
          lange == "ch" ? "艺识代知识产权/Easytimes IP" : "EasyTimes IP & 艺识代"
        }}</span>
        <span class="index_b_3">{{
          lange == "ch" ? '"一站式，全方位"知识产权专业服务平台' : "One-stop Comprehensive  "
        }}</span>
        <span class="index_b_3" v-if="lange == 'ch'" style="margin-top:2%">
          Full-range IP Service Platform
        </span>
        <span class="index_b_3">{{
          lange == "ch" ? "" : "Intellectual Property"
        }}</span>
        <span class="index_b_3">{{
          lange == "ch" ? "" : "Service Platform"
        }}</span>
        <!--<router-link
          to="##"
          class="index_b_4"
          :style="
            'background-image:url(' +
            require('../../../assets/images/in_ban_1.png') +
            ');'
          "
          ><!--{{
            lange == "ch"
              ? "点击此处，了解更多关于产权信息"
              : "Click here to learn more about property rights"
          }}</router-link-->

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndexBannerText",
  components: {},
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
    };
  },
  created() {},
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box_bain {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}
.banner_cnt {
  width: 62.5%;
  display: block;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
}
.index_b_box {
  width: 100%;
  display: block;
  margin: 16% 0 0 0;
}
.index_b_box > span {
  width: 100%;
  display: block;
}
.index_b_1 {
  font-size: 28px;
  color: #bda67d;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 400;
}
.index_b_2 {
  /* font-size: 50px; */
  color: #fff;
  margin: 5% 0 10px 0;
 font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 700;
  font-size: 20px;
}
.index_b_3 {
  font-size: 34px;
  color: #fff;
  font-weight: bold;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 700;
  margin-top: 3%;
}
.index_b_4 {
  width: 100%;
  display: block;
  margin-top: 3%;
  font-size: 20px;
  color: #bda67d;
  font-weight: bold;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 25px auto;
  padding-left: 40px;
  line-height: 30px;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
}

@media only screen and (max-width: 1440px) {
  .banner_cnt {
    width: 90%;
  }
  .index_b_box {
    margin: 6% 0 0 0;
  }
}
@media only screen and (max-width: 1024px) {
  .index_b_2 {
    font-size: 30px;
  }
  .index_b_3 {
    font-size: 30px;
  }
}
@media only screen and (max-width: 768px) {

  .index_b_box {
    margin: 3% 0 0 0;
  }
}
@media only screen and (max-width: 425px) {
  .index_b_box {
    margin: 10% 0 0 0;
  }
  .index_m_box{
    margin: 16% 0 0 0 !important;
  }
  .index_b_1 {
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  }
  .index_b_2 {
    font-size: 16px;
  }
  .index_b_3 {
    font-size: 16px;
    font-weight: 700;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  }
  .index_b_4 {
    font-size: 12px;
    font-weight: 100;
    padding-left: 19px;
    background-size: 4%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Banner/component/IndexBannerText.vue